import type { BrandConfig } from '../../../../../configs/types'

export type { BrandConfig, BrandResources, BrandTheme, BrandTexts } from '../../../../../configs/types'

// __BRAND_CONFIG__ 由 vite.config.ts define 选项在构建时注入
const brandConfig: BrandConfig = __BRAND_CONFIG__

function prefixCDN<T>(obj: T, cdn: string): T {
  if (typeof obj === 'string')
    return (obj.startsWith('/') ? cdn + obj : obj) as T
  if (typeof obj === 'object' && obj !== null) {
    const result = {} as T
    for (const key in obj)
      (result as any)[key] = prefixCDN((obj as any)[key], cdn)
    return result
  }
  return obj
}

const cdn = import.meta.env.DEV ? '' : (import.meta.env.VITE_CDN || '').replace(/\/$/, '')

export const resources = prefixCDN(brandConfig.resources, cdn)
export const { theme, texts, environments } = brandConfig
export const primaryColor = theme.primaryColor
